import Pagination from '@/model/Pagination';
import Sort from '@/model/SortReq';

export default function (other) {
  other = other || {};
  return {
    // Filter fields
    id: other.id || null,
    name: other.name || null,

    // Search
    search: other.search || '',

    // Pagination & Sorting
    pagination: other.pagination || Pagination(),
    sort: other.sort || Sort()
  };
}
